// extracted by mini-css-extract-plugin
export default {"content":"EmptyStepList_content__dzLPM","bold":"EmptyStepList_bold__99FRO","buttonBlock":"EmptyStepList_buttonBlock__nryvu","button":"EmptyStepList_button__LBpXh"};